module.exports = __webpack_public_path__ + "static/media/4@2x.b3e8189e.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_150/img/4@2x.png
// module id = 1476
// module chunks = 0